import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './AppNew.tsx'
import './index.css'
import { DemoModeProvider } from './providers/DemoModeProvider'
import { BetaModeProvider } from './providers/BetaModeProvider'
import { AuthProvider } from './providers/AuthProvider'
import { ExampleDataProvider } from './data/example/ExampleDataProvider'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AuthProvider>
      <DemoModeProvider>
        <BetaModeProvider>
          <ExampleDataProvider>
            <App />
          </ExampleDataProvider>
        </BetaModeProvider>
      </DemoModeProvider>
    </AuthProvider>
  </React.StrictMode>,
)
